module.exports = __webpack_public_path__ + "img/index_logo.024fe0e3.png";